import React, { useEffect, useState } from 'react';
import SearchBar from './SearchBar';
import youtube from '../apis/youtube';
import VideoList from './VideoList';
import VideoDetail from './VideoDetail';

const App =()=> {
    
    const [videos , setVideos] = useState([]);
    const [selectedVideo , setSelectedVideo] = useState(null) ;

    useEffect(()=>{

        onSearchSubmit('building');

    },[]);

    const onSearchSubmit = async term => {

        const Response = await youtube.get('/search',{
        params : {
            q: term
        }
    });
        setVideos(Response.data.items);
        setSelectedVideo(Response.data.items[0]);
    
    };

     

    const onVideoSelect = (video) => {
        setSelectedVideo(video);
     };
    
     return (
        <div className="ui container"> 
            <SearchBar onSubmit = {onSearchSubmit}/>
            <div className="ui grid">
              <div className= "ui row">
                   <div className="eleven wide column">
                        <VideoDetail  video ={selectedVideo}/>
                   </div>
                    <div className="five wide column">
                        <VideoList  
                        onVideoSelect={onVideoSelect}
                         videos = {videos}
                          />
                   </div>
            </div>
          </div>
          

         </div>
    );
}
 export default App;